import type { PropsWithChildren } from '@shared/utils';
import { createContext, useCallback, useMemo, useState } from 'react';

import { RoleDeletionModal } from '../../containers';

import type { RoleManagementModalContextValue, RoleManagementModalAction } from './types';

const RoleManagementModalContext = createContext<RoleManagementModalContextValue | undefined>(
  undefined,
);

export default function RoleManagementModalProvider(props: Readonly<PropsWithChildren>) {
  const { children } = props;
  const [action, setAction] = useState<RoleManagementModalAction | null>(null);
  const [id, setId] = useState<string | undefined>(undefined);

  const handleSetAction = useCallback(
    (action: RoleManagementModalAction | null, id?: string) => {
      setAction(action);
      setId(id);
    },
    [setAction],
  );

  const handleClose = useCallback(() => {
    setAction(null);
  }, []);

  const contextValue: RoleManagementModalContextValue = useMemo(() => {
    return {
      setAction: handleSetAction,
      close: handleClose,
    };
  }, [handleSetAction, handleClose]);

  return (
    <RoleManagementModalContext.Provider value={contextValue}>
      {children}
      <RoleDeletionModal open={action === 'role-deletion'} onClose={handleClose} roleId={id} />
    </RoleManagementModalContext.Provider>
  );
}

export { RoleManagementModalContext };
